import { render, staticRenderFns } from "./input-multilang.vue?vue&type=template&id=1d2b6b99&"
import script from "./input-multilang.vue?vue&type=script&lang=js&"
export * from "./input-multilang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports